import Service from '../../../api/api-service';
import { ApiUrl } from '../../../api/api-url';

const service = new Service();

export const GetAddressList = (data) => {
    const params = new URLSearchParams();
    data.streetName && params.append("StreetName", data.streetName);
    data.longitude && params.append("Longitude", data.longitude);
    data.latitude && params.append("Latitude", data.latitude);
    data.pageIndex && params.append("PageIndex", data.pageIndex);
    data.pageSize && params.append("PageSize", data.pageSize);
    return service
        .postParams('api/cms/Address/List', params)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const GetAddressById = (id) => {
    return service
        .get(`api/cms/Address/GetById/${id}`)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const GetAddressByCode = (code) => {
    return service
        .get(`api/cms/Address/GetByCode/${code}`)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};